import gql from "graphql-tag";
import applicantFragment from "../../Auth/fragments/applicantFragment";

const registerApplicantStage1 = gql`
    mutation registerApplicantStage1(
        $email: String
        $password: String
        $firstName: String
        $lastName: String
        $universitySlug: String
        $primaryApp: String
        $checkForAmbassador: Boolean
        $ageVerificationInfo: AgeVerificationInfoInputField
    ) {
        createApplicantV2(
            email: $email
            password: $password
            firstName: $firstName
            lastName: $lastName
            universitySlug: $universitySlug
            primaryApp: $primaryApp
            checkForAmbassador: $checkForAmbassador
            ageVerificationInfo: $ageVerificationInfo
        ) {
            error
            applicant {
                ...ApplicantFull
            }
        }
    }
    ${applicantFragment}
`;

export default registerApplicantStage1;
